export default "__VITE_ASSET__BArQ2RmQ__"